// Browser/Electron-safe env reads. Webpack DefinePlugin inlines process.env.* at build time;
// runtime fallbacks cover Electron and bundles served without full replacement.
function readProcessEnv() {
  try {
    if (typeof process !== 'undefined' && process.env) {
      return process.env;
    }
  } catch (_err) {
    // Electron renderer may throw when accessing process without nodeIntegration.
  }
  return {};
}

function defaultNodeEnv() {
  if (typeof window !== 'undefined') {
    const host = String(window.location?.hostname || '');
    if (host === 'localhost' || host === '127.0.0.1' || host === '[::1]') {
      return 'development';
    }
  }
  return 'production';
}

const env = readProcessEnv();

export const NODE_ENV = env.NODE_ENV || defaultNodeEnv();
export const IS_PRODUCTION = NODE_ENV === 'production';
export const SENTRY_DSN = env.SENTRY_DSN || '';
export const SENTRY_INGEST_HOST = env.SENTRY_INGEST_HOST || '';
export const SENTRY_PROJECT_ID = env.SENTRY_PROJECT_ID || '';
export const SENTRY_ENVIRONMENT = env.SENTRY_ENVIRONMENT || 'production';
export const SENTRY_TRACES_SAMPLE_RATE = env.SENTRY_TRACES_SAMPLE_RATE || '0.1';
